import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import { fetchTradeOnApprovalEligibility } from './fetchTradeOnApprovalEligibility';
import { ComponentLoader } from '../../global/ComponentLoader/ComponentLoader';

class PdpRespTradeOnApprovalCoachmarkLoaderComponent extends Component {
    constructor(props) {
        super(props);
        this.checkEligibility = this.checkEligibility.bind(this);
        this.getLoadFunc = this.getLoadFunc.bind(this);
        this.state = {
            eligibilityChecked: false,
            userEligibleForOnApproval: false, // updated when relay prop received
        };
    }

    componentDidMount() {
        this.checkEligibility();
    }

    componentDidUpdate() {
        this.checkEligibility();
    }

    checkEligibility() {
        const { relay, user, item } = this.props;
        const { eligibilityChecked } = this.state;
        const relayEnvironment = get(relay, 'environment');
        const userId = get(user, 'serviceId');
        const itemId = get(item, 'serviceId');

        if (eligibilityChecked || !relayEnvironment || !userId) {
            return;
        }

        this.setState({ eligibilityChecked: true }, () => {
            fetchTradeOnApprovalEligibility(relayEnvironment, userId, itemId).then(
                userEligibleForOnApproval => {
                    this.setState({ userEligibleForOnApproval });
                }
            );
        });
    }

    getLoadFunc() {
        return import(/* webpackChunkName: "PdpRespTradeOnApprovalCoachmark" */
        './PdpRespTradeOnApprovalCoachmark').then(
            moduleExport => moduleExport.PdpRespTradeOnApprovalCoachmark
        );
    }

    render() {
        const { userEligibleForOnApproval } = this.state;

        return (
            <ComponentLoader
                load={userEligibleForOnApproval}
                importFunc={this.getLoadFunc}
                useLoadingComponent={false}
            />
        );
    }
}

PdpRespTradeOnApprovalCoachmarkLoaderComponent.propTypes = {
    item: PropTypes.object,
    relay: PropTypes.object,
    user: PropTypes.object,
};

export const PdpRespTradeOnApprovalCoachmarkLoader = createFragmentContainer(
    PdpRespTradeOnApprovalCoachmarkLoaderComponent,
    {
        item: graphql`
            fragment PdpRespTradeOnApprovalCoachmarkLoader_item on Item {
                serviceId
            }
        `,
        user: graphql`
            fragment PdpRespTradeOnApprovalCoachmarkLoader_user on User {
                serviceId
            }
        `,
    }
);
